import { Box } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"
import DropzoneComponent from "react-dropzone-component"
import styled from "styled-components"

import { SectionTitle, Text } from "areas/order/components"

const Wrapper = styled(Box)`
  padding: 24px 0;
  width: 100%;
  ${(props) => props.theme.mediaQueries.tablet`
    width: 470px;
  `}
`

const StyledDropzone = styled(DropzoneComponent)`
  display: flex;
  flex-flow: row-reverse;
  flex-wrap: wrap-reverse;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  padding: 40px;
  min-height: 150px;
  border: 2px dashed ${(props) => props.theme.colors.grey10};
  cursor: pointer;

  .dz-message {
    font-size: 18px;
    text-align:center;
    margin: 15px;
    height: auto;
    width: 250px;
    ${({ theme }) => theme.mediaQueries.tablet`
        height: 170px;
     `};
  }
   .dz-message .hide-mobile{
     display: none;
     ${({ theme }) => theme.mediaQueries.tablet`
       display: block;
       margin-right: auto;
       margin-left: auto;
     `};
  }

  .dz-preview {
    position: relative;
    padding-top: 40px;
    min-height: 100px;
    margin: 15px;
    &:hover {
      .dz-image {
        filter: blur(8px);
      }
      .dz-details {
        opacity: 1;
      }
    }
    .dz-file-preview {
      .dz-details {
        opacity: 1;
      }
    }
  }
  .dz-image {
    width: 250px;
    height: 170px;
    margin: auto;
    border: 1px solid #999;
    overflow: hidden;
    img {
      width: 250px;
      height: 170px;
    }
  }
  .dz-details {
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    padding: 20px 10px;
    width: 100%;
    text-align: center;
    .dz-size,
    .dz-filename {
      padding: 0 5px;
      background-color: rgba(255, 255, 255, 0.8);
      border-radius: 2px;
    }
    .dz-size {
      display: inline-block;
      margin-bottom: 10px;
    }
    .dz-filename {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .dz-upload {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    width: 0;
    background: #333;
    background: linear-gradient(to bottom, #666, #444);
    transition: width: .3s ease-in-out;
  }
  .dz-success-mark,
  .dz-error-mark {
    position: absolute;
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 0;
    width: 100%;
    height: 100%;
  }
  .dz-remove {
    position: relative;
    z-index: 10;
    display: block;
    font-size: 14px;
    color: ${(props) => props.theme.colors.primary};
    text-align: center;
    line-height: 2;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
  .dz-error-message {
    position: absolute;
    top: -25px;
    left: 50%;
    transform: translateX(-50%);
    width: 160px;
    padding: 10px;
    color: white;
    opacity: 0;
    background: #be2626;
    background: linear-gradient(to bottom, #be2626, #a92222);
    border-radius: 8px;
    &:after {
      content: '';
      position: absolute;
      bottom: -6px;
      left: 50%;
      transform: translateX(-50%);
      width: 0;
      height: 0;
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
      border-top: 6px solid #be2626;
    }
  }
  .dz-error {
    .dz-error-message,
    .dz-error-mark {
      opacity: 1;
    }
    .dz-progress {
      opacity: 0;
    }
  }
`

const Dropzone = ({ error, setValue }) => {
  let dropzone = null
  const componentConfig = { postUrl: "none" }
  const eventHandlers = {
    addedfile: () => {
      setValue("files", dropzone.files, { shouldTouch: true })
    },

    init: (drop) => (dropzone = drop),
    removedfile: () => {
      setValue("files", dropzone.files)
    },
  }
  const djsConfig = {
    acceptedFiles: "image/jpeg,image/png",
    addRemoveLinks: true,
    autoProcessQueue: false,
    maxFiles: 5,
    maxFilesize: 8,
    parallelUploads: 5,
    thumbnailHeight: 170,
    thumbnailWidth: 250,
    uploadMultiple: true,
  }
  return (
    <Wrapper>
      <SectionTitle>Photos</SectionTitle>
      <Text pb={2}>
        Please upload at least 2 clear photos of your item lying on a flat
        surface. This will help determine how we can best assist you with your
        repair.
      </Text>

      <Text color="error" fontWeight="500" mb={1}>
        {error}
      </Text>
      <StyledDropzone
        className="dropzone"
        config={componentConfig}
        djsConfig={djsConfig}
        eventHandlers={eventHandlers}
      >
        <div className="dz-message">
          <div className="hide-mobile">
            <img
              alt="upload file"
              src={require("images/jewlr/file_upload.svg")}
              width="30px"
            />
            <p> Drag and drop files here to upload</p>
            <p>Or</p>
          </div>

          <img
            alt="upload file"
            src={require("images/jewlr/file_upload_device.svg")}
            width="250px"
          />
        </div>
        <div className="dz-preview dz-image-preview"> </div>
      </StyledDropzone>
    </Wrapper>
  )
}

Dropzone.propTypes = {
  error: PropTypes.string,
  setValue: PropTypes.func,
}

export default Dropzone
